"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reflexbox_1 = require("reflexbox");
var Components_1 = require("../../Components");
var GridWrapper = styled_components_1["default"](reflexbox_1.Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    justify-content: center;\n"], ["\n    justify-content: center;\n"])));
exports.Grid = function (props) {
    return (React.createElement(GridWrapper, { flexWrap: "wrap" }, props.blok.Body && props.blok.Body.map(function (blok) { return React.createElement(Components_1.Components(blok.component), { key: blok._uid, blok: blok }); })));
};
var templateObject_1;
